import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardWrapper, CardHeader, CardSection } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QueuedFieldsCardWrapper = ({
  children,
  isExpanded,
  handleExpandedChange,
  queuedFormFieldGroups
}) => /*#__PURE__*/_jsxs(CardWrapper, {
  id: "progressive-fields-wrapper",
  "data-test-id": "progressive-fields-wrapper",
  expandable: true,
  expanded: isExpanded,
  onExpandedChange: handleExpandedChange,
  children: [/*#__PURE__*/_jsx(CardHeader, {
    id: "queued-fields-header",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editor.form.queuedFields.title",
      options: {
        queuedFieldsNumber: queuedFormFieldGroups.length
      }
    })
  }), /*#__PURE__*/_jsx(CardSection, {
    children: children
  })]
});
export default QueuedFieldsCardWrapper;